export const _typeof = type => {
  // return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
  return obj => Object.prototype.toString.call(obj) === `[object ${type}]`
}

export const isObject = _typeof('Object')

export const isString = _typeof('String')

export const isNumber = _typeof('Number')

export const isArray = obj => Array.isArray(obj)

export const isNonEmptyArray = (obj = []) => {
  return (
    obj && obj.length > 0 && Array.isArray(obj) && typeof obj !== 'undefined'
  )
}
export const isEmptyObject = obj =>
  obj &&
  isObject(obj) &&
  Object.keys(obj).length === 0 &&
  obj.constructor === Object

/**
 * isPlainObject(node=document.getElementById("xx")) -> false
 * toString.call(node) : ie678 == '[object Object]',other =='[object HTMLElement]'
 * 'isPrototypeOf' in node : ie678 === false ,other === true
 * @param {*} obj
 */
export const isPlainObject = obj =>
  obj && isObject(obj) && 'isPrototypeOf' in obj

/**
 * 'null', 'undefined', '', null, undefined
 * @param {*} arg
 */
export const isNullOrEmpty = arg =>
  (typeof arg === 'string' &&
    (arg.toLowerCase() == 'null' || arg.toLowerCase() == 'undefined')) ||
  (!arg && arg !== 0 && typeof arg != 'boolean' ? true : false)

/**
 * 'null', 'undefined', '', null, undefined
 * @param {*} arg
 */
export const emptyReplace = arg => (isNullOrEmpty(arg) ? '--' : arg)
export const emptyNoReplace = arg =>
  isNullOrEmpty(arg) ? '--' : (+arg).toFixed(2)
export const emptyMoneyReplace = arg => (isNullOrEmpty(arg) ? '0' : +arg)
/**
 * true,'true'=>true
 * false,'false'=>false
 * @param {*} bool
 */
export const isTrue = bool => /true/.test(bool.toString())

/**
 * 比较2个对象是否相同
 * @param {o1,o2} Object
 */
export const isObjEqual = (o1, o2) => {
  var props1 = Object.getOwnPropertyNames(o1)
  var props2 = Object.getOwnPropertyNames(o2)
  if (props1.length != props2.length) {
    return false
  }
  for (var i = 0, max = props1.length; i < max; i++) {
    var propName = props1[i]
    if (o1[propName] !== o2[propName]) {
      return false
    }
  }
  return true
}

/**
* 防抖
* @param {*} func
* @param {*} wait
* @param {*} immediate
*/
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function() {
    args = arguments;
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}


export function toPercent(point) {
  if (point !== "--") {
    var str = Number(point * 100).toFixed(2);
    str += "%";
    return str;
  } else {
    return "--"
  }
}
// 判断 obj是否有某个参数
export function hasKey(obj, s) {
  s = s.split('.');
  var objNew = obj[s.shift()];
  while (objNew && s.length) objNew = objNew[s.shift()];
  return objNew;
}